module.exports = __webpack_public_path__ + "img/img_option_sample.dc8b5069.svg";